import React from 'react';
import { Box } from '@components/Box';
import { rachelZoePageData } from '@data-ts/pages/rachel-zoe';
import { EnterNowButton } from '@sections/rachel-zoe/components/EnterNowButton';
import { PositionedStaticImages } from '@sections/rachel-zoe/components/PositionedStaticImages';
import { getRootUrl } from '@utils/urlHelpers.util';
import { PLAY_SPEED, AUTO_PLAY_INTERVAL, groupImages, keyImage, SECTION_ID, EASING } from './WeddingSuiteSection.constants';
import {
  StyledTextPairing,
  Swiper,
  SwiperButton,
  Wrapper,
  ImagesWrapper,
  BodyWrapper,
  StyledCloudImage,
  StyledCarousel,
} from './WeddingSuiteSection.styles';
import { JoykitIcon } from '@components/JoykitIcon';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import { useWeddingSuiteSectionController } from './WeddingSuiteSection.controller';

const weddingSuiteData = rachelZoePageData.sections.weddingSuite;

export const WeddingSuiteSection: React.FC = () => {
  const {
    activeSlide,
    isMobileDevice,
    isScrolledIntoView,
    setIsScrolledIntoView,
    handleChangeSlide,
    handleBeforeSlide,
    handleAfterSlide,
  } = useWeddingSuiteSectionController(groupImages.length);
  return (
    <Box as="section" id={SECTION_ID} marginTop={[14, 9]} marginBottom={[0, 13]}>
      <LazyLoadWrapper beforeLoad={() => setIsScrolledIntoView(true)}>
        <div />
      </LazyLoadWrapper>
      <Wrapper>
        <StyledCarousel
          easing={EASING}
          dragging={false}
          wrapAround={isMobileDevice}
          autoplay={isMobileDevice}
          renderAnnounceSlideMessage={({ currentSlide, slideCount }) => ''}
          autoplayInterval={AUTO_PLAY_INTERVAL}
          speed={PLAY_SPEED}
          slideIndex={activeSlide}
          withoutControls={true}
          beforeSlide={handleBeforeSlide}
          afterSlide={handleAfterSlide}
        >
          {groupImages.map((groupImage, index) => (
            <ImagesWrapper key={`Positioned_Static_Images_${index}`}>
              <PositionedStaticImages images={groupImage} isMainSrcShown={isScrolledIntoView} />
            </ImagesWrapper>
          ))}
        </StyledCarousel>
        <ImagesWrapper>
          <BodyWrapper flexDirection="column" alignItems="center">
            <StyledCloudImage src={keyImage.url} mobile={keyImage.belowSm} sm={keyImage.sm} />
            <StyledTextPairing
              eyebrow={weddingSuiteData.eyebrow}
              eyebrowVariant="sectionEyeBrow24"
              eyebrowColor="neutra5"
              eyebrowTagName="h3"
              title={weddingSuiteData.title}
              titleVariant="hed56"
              titleColor="neutra6"
              titleTagName="h2"
              body={weddingSuiteData.body}
              bodyVariant="dek24"
              bodyColor="neutra5"
              alignment="center"
            />
            <Swiper flexDirection="row" marginBottom={9} marginTop={10}>
              <SwiperButton onClick={() => handleChangeSlide('prev')} justifyContent="center" alignItems="center">
                <JoykitIcon name="backChevron" color="neutra6" size={24} />
              </SwiperButton>
              <SwiperButton onClick={() => handleChangeSlide('next')} justifyContent="center" alignItems="center">
                <JoykitIcon name="forwardChevron" color="neutra6" size={24} />
              </SwiperButton>
            </Swiper>
            <Box marginTop={6} style={{ textAlign: 'center' }}>
              <EnterNowButton
                id="weddingSuiteViewTheCollectionAndEnterNow"
                href={getRootUrl('/designs?collection=rachelzoe')}
                variant="defaultPrimary"
              >
                {weddingSuiteData.cta}
              </EnterNowButton>
            </Box>
          </BodyWrapper>
        </ImagesWrapper>
      </Wrapper>
    </Box>
  );
};
